import React, { useEffect } from 'react';
import scanner1 from '../../assets/images/scanner1.png';
import scanner2 from '../../assets/images/scanner2.png';
import scanner3 from '../../assets/images/scanner3.png';

function SelectDeviceType({setDeviceType,deviceType, setAepsStatus,aepsStatus})  {

	


    const select = (device) =>{
        setDeviceType(device)
        localStorage.setItem("InstantPaydeviceType",device)
      if(aepsStatus === 'SELECT_DEVICE_FOR_LOGIN'){
        setAepsStatus("CAPTUR_FOR_LOGIN");
      }else{
        setAepsStatus("TRANSACTION_SCREEN");
      }
    }

    return(
		<div className="tab-content-left">
					<h2>Select Device Type</h2>
					<div className="scanner">
						<div className={`scanner1 flex gap-30 ${(deviceType === 'Mantra')?"active":""}`} onClick={() =>select("Mantra")}>
							<input type="radio" checked={deviceType === 'Mantra'} />
							<div className="device flex">
								<img src={scanner1} alt="Mantra" />
								<p>Mantra</p>
							</div>
						</div>
						<div className={`scanner1 flex gap-30 ${(deviceType === 'Morpho')?"active":""}`}  onClick={() =>select("Morpho")}>
							<input type="radio" checked={deviceType === 'Morpho'} />
							<div className="device flex">
								<img src={scanner2} alt="Morpho" />
								<p>Morpho</p>
							</div>
						</div>
						<div className={`scanner1 flex gap-30 ${(deviceType === 'Tatvik')?"active":""}`}  onClick={() =>select("Tatvik")}>
							<input type="radio" checked={deviceType === 'Tatvik'} />
							<div className="device flex">
								<img src={scanner3} alt="Tatvik" />
								<p>Tatvik</p>
							</div>
						</div>
					</div>
				
				</div>
	)
}

export default SelectDeviceType